module.exports = __webpack_public_path__ + "common/icon-arrow-down-ac24a16a8a89a188e066a421ac155168.svg";